import { useQuery } from "@tanstack/react-query";
import { getWaiters } from "@/api/Waiters/WaitersAPI";
import type { Waiter } from "@/api/Waiters/WaitersAPI.model";
import { queryKeys } from "@/lib/queryKeys";

const EMPTY: Waiter[] = [];

/**
 * The staff a guest can direct their tip to.
 *
 * Failure is silent on purpose: a tip with nobody named still reaches the
 * venue, so a dead list must never stand between a guest and paying.
 */
export const useWaiters = (restaurantId: string): Waiter[] => {
  const { data } = useQuery({
    queryKey: queryKeys.waiters(restaurantId),
    queryFn: () => getWaiters(restaurantId),
    enabled: Boolean(restaurantId),
  });

  return data ?? EMPTY;
};
